<template>
  <div class="home">
    
    
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {
    
  },
  async created() {
    //console.log('1');
  },
}
</script>
